export const state = {
  access_Token: "",
  loggedIn: false,
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  registration: {
    username: "",
    password: "",
    confirmPassword: "",
    otp: "",
    firstname: "",
    lastname: "",
    gender: "",
    birthdate: "",
    mobile_no: "",
    email: "",
    village: "",
    district: "",
    province: "",
    nationality: "",
    career: "",
  },
};
